<script setup lang="ts">
import type { NuxtError } from '#app'

const props = defineProps<{
  error: NuxtError
}>()

const statusCode = computed(() => props.error?.statusCode || 500)

const title = computed(() => {
  switch (statusCode.value) {
    case 401: return 'Non authentifie'
    case 403: return 'Acces refuse'
    case 404: return 'Page introuvable'
    default: return 'Erreur serveur'
  }
})

const description = computed(() => {
  switch (statusCode.value) {
    case 401: return 'Vous devez etre connecte pour acceder a cette page.'
    case 403: return 'Vous n\'avez pas les permissions necessaires.'
    case 404: return 'La page que vous cherchez n\'existe pas.'
    default: return 'Une erreur inattendue s\'est produite.'
  }
})

function handleError() {
  clearError({ redirect: '/' })
}
</script>

<template>
  <!--
    `data-error-page` et `data-status` donnent aux tests un marqueur stable :
    chercher « 403 » dans le texte de la page confondait un refus d'accès avec
    un chiffre de données (le registre RNIC affiche « 103 655 résultats »).
  -->
  <div
    class="min-h-screen flex items-center justify-center bg-[var(--ui-bg)]"
    data-error-page
    :data-status="statusCode"
  >
    <div class="text-center max-w-md px-6">
      <p class="text-6xl font-bold text-[var(--ui-text-muted)]">
        {{ statusCode }}
      </p>
      <h1 class="mt-4 text-2xl font-semibold text-[var(--ui-text)]">
        {{ title }}
      </h1>
      <p class="mt-2 text-[var(--ui-text-muted)]">
        {{ description }}
      </p>
      <div class="mt-8">
        <UButton label="Retour a l'accueil" @click="handleError" />
      </div>
    </div>
  </div>
</template>
